import { render, staticRenderFns } from "./OperatorAccept.vue?vue&type=template&id=264f848d&lang=pug&"
import script from "./OperatorAccept.vue?vue&type=script&lang=js&"
export * from "./OperatorAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports